import React, { useState, useEffect } from "react";
import useStyles from "../style";
import useStylesTable from "../../settings/styles";
import { useLocation } from "react-router-dom";
import config from "../../../config";

// components
import InputComponent from "./inputComponent";
import InputSelect from "./inputSelect";
import InputSelectMembershipType from "./inputSelectMembershipType";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { CircularProgress } from "@material-ui/core";
import InputDisableAge from "../../user/components/inputDisableAge";
import InputDisableSimpleText from "../../user/components/inputDisableSimpleText";
import { TextField } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import Modal from "../../modals/Modal";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell
} from "@material-ui/core";

export default function PartnerInfoOneDay() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
    }

    const classes = useStyles();
    const location = useLocation();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [name, setName] = useState({ text: '', valid: null });
    const [lastName, setLastName] = useState({ text: '', valid: null });
    const [membershipType, setMembershipType] = useState({ text: '', cost: 0, valid: null });
    const [partnerStatus, setPartnerStatus] = useState({ text: '', valid: null });
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');
    const [membershipStartDate, setMembershipStartDate] = useState('');
    const [membershipStartDateValue, setMembershipStartDateValue] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [dueDateValue, setDueDateValue] = useState('');
    const [lastAccessDate, setLastAccessDate] = useState('');

    const [partnerInfo, setPartnerInfo] = useState([]);
    const [allMembershipType, setAllMembershipType] = useState([]);
    const [allStatus, setAllStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingToSaveUser, setIsLoadingToSaveUser] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    function getValue(value) {
        var year = value.substring(6);
        var month = value.substring(3, 5);
        var day = value.substring(0, 2);

        return year + "-" + month + "-" + day;
    }

    const fetchPartnerInfo = async () => {
        var id = '';

        try {
            if (location.state.id == null) {
                id = location.state.id;
            } else {
                id = localStorage.getItem('partnerOneDayInfo');
            }
        } catch (e) {
            id = localStorage.getItem('partnerOneDayInfo');
        }

        fetch(baseUrl + "partnerForOneDayById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setPartnerInfo(data);
                    setName({ text: data.name, valid: 'true' });
                    setLastName({ text: data.lastName, valid: 'true' });
                    setMembershipType({ text: data.membershipType, cost: data.cost, valid: 'true' });
                    setPartnerStatus({ text: data.partnerStatus, valid: 'true' });
                    setMembershipStartDate(data.membershipStartDate);
                    setMembershipStartDateValue(getValue(data.membershipStartDate));
                    setDueDateValue(getValue(data.dueDate));
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);
                    setDueDate(data.dueDate);
                    setLastAccessDate(data.lastAccessDate);
                } else {
                    setShowModal(true);
                }

                setIsLoading(false);
            })
            .catch(error => null);
    }

    const fetchMembershipType = async () => {
        if (!showModal) {
            fetch(baseUrl + "membershipOneDay",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllMembershipType(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchStatus = async () => {
        if (!showModal) {
            fetch(baseUrl + "genericStatus",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllStatus(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchPartnerInfo();
        fetchMembershipType();
        fetchStatus();
    }, [location]);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSaveUser(true);

        const newPartner = {
            id: partnerInfo.id, name: name.text, lastName: lastName.text, membershipType: membershipType.text,
            partnerStatus: partnerStatus.text, dueDate: dueDate
        };

        const response = await fetch(baseUrl + "updatePartnerForOneDay", {
            method: 'PUT',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(newPartner)
        });

        const json = await response.json();
        if (json.message == "Ok") {

        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveUser(false);

        fetchPartnerInfo();
    }

    const onDelete = async e => {
        e.preventDefault();
        /*setIsLoadingToSaveUser(true);

        const response = await fetch(baseUrl + "deletePartner/" + partnerInfo.id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.setItem('partnerInfo', '');
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveUser(false);*/
    }

    const onChangeDatePickerStart = (e) => {
        setCreationDate(e.target.value);
    }

    const onChangeDatePickerDueDate = (e) => {
        setDueDate(e.target.value);
    }

    const handleChange = (e) => {
        const value = e.target.value;
        var cost = 0;

        if (value != '') {
            allMembershipType.map((option) => {
                if (option.name == value) {
                    cost = option.cost;
                }
            });

            setMembershipType({ ...membershipType, text: value, cost: cost, valid: 'true' });
        } else {
            setMembershipType({ ...membershipType, text: value, cost: cost, valid: 'false' });
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <div className={classes.titleRow}>
                <PageTitle title="Información del socio" />

                {isLoading ? (
                    <></>
                ) : (
                    <>
                        <div className={classes.marginAuto} />
                        <div className={classes.divActionButton} >
                            <Edit classes={{ root: classes.searchIcon }}
                                onClick={() => {
                                    setDisableInpunts(!disableInpunts);
                                }}
                            />
                        </div>
                        <div className={classes.divActionButtonDisable} >
                            <Delete
                                classes={{ root: !disableInpunts ? classes.activeButtonDisable : classes.searchIcon }}
                                onClick={!disableInpunts ? null : onDelete}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className={classes.divCard} >
                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <div className={classes.divColumn} >
                        <InputComponent
                            text={name}
                            setPartnerCode={setName}
                            type="text"
                            label="Nombres"
                            name="name"
                            regularExpression={expressions.nombre}
                            placeholder="Nombre"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={lastName}
                            setPartnerCode={setLastName}
                            type="text"
                            label="Apellidos"
                            name="lastName"
                            regularExpression={expressions.nombre}
                            placeholder="Apellidos"
                            isEnable={disableInpunts}
                        />

                        <div>
                            <div className={classes.divLabel}>
                                <p className={classes.label} >{"Acceso por día"}</p>
                                <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                            </div>
                            <FormControl className={classes.formControl}>
                                <Select
                                    onChange={handleChange}
                                    displayEmpty
                                    disabled={disableInpunts}
                                    value={membershipType.text}
                                    style={{ color: "#FFFFFF" }}
                                >
                                    <MenuItem value=""> Selecciona </MenuItem>
                                    {allMembershipType.map((option) => (
                                        <MenuItem value={option.name}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <InputSelect
                            text={partnerStatus}
                            setValue={setPartnerStatus}
                            label={"Estatus"}
                            options={allStatus}
                            isEnable={disableInpunts}
                        />

                        <InputDisableSimpleText
                            value={lastAccessDate}
                            type="text"
                            label="Fecha del último acceso"
                            name="lastAccessDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />

                        <InputDisableSimpleText
                            value={creationDate}
                            type="text"
                            label="Fecha de alta"
                            name="creationDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />

                        <InputDisableSimpleText
                            value={lastUpdateDate}
                            type="text"
                            label="Última modificación"
                            name="lastUpdateDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />

                        <div className={classes.divDate}>
                            <label className={classes.labelDate} >Fecha de inicio de membrecía</label>
                            <TextField
                                type="date"
                                defaultValue={membershipStartDateValue}
                                className={classes.inputDate}
                                onChange={onChangeDatePickerStart}
                                style={{ width: '85%' }}
                                disabled={disableInpunts}
                                inputStyle={{ width: '85%' }}
                            />
                        </div>

                        <div className={classes.divDate}>
                            <label className={classes.labelDate} >Fecha de expiración de membrecía</label>
                            <TextField
                                type="date"
                                defaultValue={dueDateValue}
                                className={classes.inputDate}
                                onChange={onChangeDatePickerDueDate}
                                style={{ width: '85%' }}
                                disabled={disableInpunts}
                                inputStyle={{ width: '85%' }}
                            />
                        </div>
                    </div>
                )}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSaveUser ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>
                        ) : (
                            <button
                                className={classes.enableButton}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
